import { displayBoardBasisHe } from "./displayBoardBasisHe";

function formatIsoDateDdMmYyyy(raw) {
  const s = String(raw || "").trim();
  const iso = s.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (!iso) return "";
  return `${iso[3]}/${iso[2]}/${iso[1]}`;
}

function splitDateRange(label) {
  const m = String(label || "").match(
    /(\d{4}-\d{2}-\d{2})\D+(\d{4}-\d{2}-\d{2})/
  );
  if (!m) return { checkIn: "", checkOut: "" };
  return { checkIn: m[1], checkOut: m[2] };
}

/**
 * Hotel header stay line. Dates and meal basis stay separate so a code
 * such as RO cannot stick to the checkout date.
 */
export function formatHotelStayHeader({
  checkIn,
  checkOut,
  dateRangeLabel,
  board,
} = {}) {
  const parsed = splitDateRange(dateRangeLabel);
  const from = formatIsoDateDdMmYyyy(checkIn || parsed.checkIn);
  const to = formatIsoDateDdMmYyyy(checkOut || parsed.checkOut);
  const dates = from && to ? `${from} – ${to}` : from || to || "";
  const boardLabel = displayBoardBasisHe(board);
  const line = [dates, boardLabel].filter(Boolean).join(" | ");
  return { dates, boardLabel, line };
}
